import { render, staticRenderFns } from "./Cpf.vue?vue&type=template&id=5e8d99df&"
import script from "./Cpf.vue?vue&type=script&lang=js&"
export * from "./Cpf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports